<template>
    <div>

        <div v-if="groups_ids">
            <v-card v-for="(group, index) in groups_ids" :key="index">
                <p v-if="group.show">{{ group }}</p>
            </v-card>
            <div v-if="!headers"> ... reading ... </div>
            <v-data-table v-if="headers" :headers="headers" :items="myStudents" :items-per-page="20"
                class="elevation-0 card-border-style" :dark="isDarkMode" dense></v-data-table>
        </div>
    </div>
</template>

<script>
import axios from '../../axios-auth.js'
import { mapGetters } from 'vuex'


export default {
    data() {
        return {
            group_id: 0,
            headers: null,
            myStudents: null,
            students: null,
            chapters: null,
            igroups: null,
            typeRes: 0
        }
    },
    computed:
        mapGetters([
            'isDarkMode'
        ])
    ,
    mounted() {
        this.initData()
    },
    props: ['groups_ids', 'course_id'],
    watch: {
        groups_ids() {
            this.refreshData()
            return this.groups_ids
        }
    },
    methods: {
        initData() {
            let _data = {
                course_id: this.course_id
            }
            axios.post('/get-courses-groups-students', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.chapters = res.data.chapters
                    this.students = res.data.students
                    this.refreshData()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        refreshData() {
            this.headers = []
            this.headers.push({ text: "surname", value: "surname" })
            this.headers.push({ text: "name", value: "name" })
            var st = 0
            var svpl = 0
            for (let i = 0; i < this.chapters.length; i++) {
                this.headers.push({
                    text: this.chapters[i].chapter_name.substring(0, 15) + '... (' + this.chapters[i].max_tasks + '/' + this.chapters[i].max_programs + ')',
                    value: 'ch' + this.chapters[i].id
                })
                st += parseInt(this.chapters[i].max_tasks)
                svpl += parseInt(this.chapters[i].max_programs)
            }
            this.headers.splice(2, 0, { text: "score (" + st + "/" + svpl + ")", value: "sump" })
            this.headers.splice(2, 0, { text: "% ", value: "perc" })
            this.headers.splice(2, 0, { text: "score (" + (st + svpl) + ")", value: "sum" })
            this.myStudents = []
            for (let i = 0; i < this.students.length; i++) {
                if (this.groups_ids.indexOf(this.students[i].group_id) > -1) {
                    var tmp = {}
                    tmp['name'] = this.students[i].name
                    tmp['surname'] = this.students[i].surname
                    var t = 0
                    var vpl = 0
                    for (let j = 0; j < this.students[i].chapters.length; j++) {
                        tmp['ch' + this.students[i].chapters[j].id] = this.students[i].chapters[j].score_tasks + "/" + this.students[i].chapters[j].score_programs
                        t += parseInt(this.students[i].chapters[j].score_tasks)
                        vpl += parseInt(this.students[i].chapters[j].score_programs)
                    }
                    tmp['sum'] = t + vpl
                    tmp['sump'] = t + '/' + vpl
                    tmp['perc'] = this.getPerc(t / st) + "/" + this.getPerc(vpl / svpl) + '%'
                    this.myStudents.push(tmp)
                }
            }
        },
        getPerc(y) {
            const x = Math.round(y * 1000) / 10
            var perc = ''
            if (x < 10) perc = '0' + x
            else perc = perc + x
            if (perc.indexOf('.') < 0 && (x < 100)) perc = perc + '.0'
            return perc
        }
    }
}
</script>